export const CommerceDataEn = {
    form: {
        inputs: {
            name: {
                label: "name*",
                placeholder: "Ex. Maria torres Martínez",
            },
            company: {
                label: "company name*",
                placeholder: "Ex. Example SL",
            },
            email: {
                label: "email*",
                placeholder: "Ex. example@gmail.com",
                error: "Invalid email format*",
            },
            phone: {
                label: "phone*",
                placeholder: "Ex. +34 000 000 000",
                error: "Invalid phone format*",
            },
            type: {
                label: "what type of business are you?*",
                type_options: [],
            },
            location: {
                label: "select the location of your company*",
            },
        },
        button: "Send request",
    },
    success: {
        message: "The form has been submitted successfully",
        button: "Send another request",
    },
    error: {
        message: "There was an error while submitting the request",
        button: "Retry",
    },
};
